"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VALID_MINI_YOUTUBE_HOST_NAMES = exports.VALID_YOUTUBE_HOST_NAMES = exports.UPLOADED_CONTENT_MAX_FILE_SIZE = exports.GENERATE_ID_PLACEHOLDER = exports.WF_MAX_GENERATION_ALTERNATIVE_WORDS = exports.WF_MIN_GENERATION_ALTERNATIVE_WORDS = exports.WF_MIN_GENERATION_COUNT = exports.MC_MIN_GENERATION_COUNT = exports.MC_WRONG_ANSWERS_COUNT = exports.TEXT_BLOCK_GENERATION_MAX_SUMMARIES = exports.TEXT_BLOCK_GENERATION_MIN_SUMMARIES = exports.TEXT_BLOCK_GENERATION_MIN_SUMMARIES_PER_CHARACTER = exports.TEXT_BLOCK_MIN_CHARS = exports.TEXT_BLOCK_MAX_CHARS = exports.TRANSCRIPT_GENERATED_RESOURCE_TEXT_MIN_CHARS = exports.MAX_QUIZ_MODULES = exports.QUIZ_OVERVIEW_NAME_MAX_CHARS = exports.QUIZ_OVERVIEW_NAME_MIN_CHARS = exports.DEFAULT_QUERY_QUIZ_OVERVIEW_LIMIT = exports.DEFAULT_REGION = exports.REGION_YOUTUBE_LANGUAGE_MAP = exports.RegionDetails = exports.SUPPORTED_REGIONS = exports.MAX_GENERATE_MODULE_RETRIES = exports.TOKENS_PER_CHARACTER = exports.MAX_RESPONSE_TOKENS = exports.MAX_MODEL_GPT4O_TOKENS = exports.TEMPERATURE = exports.MODEL_GPT4O = exports.NON_PREMIUM_QUIZ_GENERATION_LIMIT = exports.TRANSCRIPT_QUIZ_RESOURCE_MAX_CHARS = exports.QUIZ_RESOURCE_MIN_CHARS = exports.QUIZ_RESOURCE_MAX_CHARS = exports.SERVICE_NAME = void 0;
__exportStar(require("./ErrorCodes"), exports);
__exportStar(require("./GenerationErrorReasons"), exports);
__exportStar(require("./Prompts"), exports);
exports.SERVICE_NAME = 'user-quiz-service';
exports.QUIZ_RESOURCE_MAX_CHARS = 40000;
exports.QUIZ_RESOURCE_MIN_CHARS = 5;
exports.TRANSCRIPT_QUIZ_RESOURCE_MAX_CHARS = 200000;
// TODO: use trials service value when monorepo-ed
exports.NON_PREMIUM_QUIZ_GENERATION_LIMIT = 3;
exports.MODEL_GPT4O = 'gpt-4o';
exports.TEMPERATURE = 0.1;
exports.MAX_MODEL_GPT4O_TOKENS = 128000;
exports.MAX_RESPONSE_TOKENS = 4096;
exports.TOKENS_PER_CHARACTER = 1 / 4;
exports.MAX_GENERATE_MODULE_RETRIES = 3;
exports.SUPPORTED_REGIONS = {
    GB: 'GB',
    DE: 'DE',
    AT: 'AT',
    FR: 'FR',
    ES: 'ES',
    IT: 'IT'
};
exports.RegionDetails = {
    [exports.SUPPORTED_REGIONS.GB]: {
        name: 'UK',
        code: 'en-GB'
    },
    [exports.SUPPORTED_REGIONS.DE]: {
        name: 'Germany',
        code: 'de-DE'
    },
    [exports.SUPPORTED_REGIONS.AT]: {
        name: 'Austria',
        code: 'de-AT'
    },
    [exports.SUPPORTED_REGIONS.FR]: {
        name: 'France',
        code: 'fr'
    },
    [exports.SUPPORTED_REGIONS.ES]: {
        name: 'Spain',
        code: 'es'
    },
    [exports.SUPPORTED_REGIONS.IT]: {
        name: 'Italy',
        code: 'it'
    }
};
exports.REGION_YOUTUBE_LANGUAGE_MAP = Object.freeze({
    [exports.SUPPORTED_REGIONS.GB]: 'en',
    [exports.SUPPORTED_REGIONS.DE]: 'de',
    [exports.SUPPORTED_REGIONS.AT]: 'de',
    [exports.SUPPORTED_REGIONS.FR]: 'fr',
    [exports.SUPPORTED_REGIONS.ES]: 'es',
    [exports.SUPPORTED_REGIONS.IT]: 'it'
});
exports.DEFAULT_REGION = exports.SUPPORTED_REGIONS.GB;
exports.DEFAULT_QUERY_QUIZ_OVERVIEW_LIMIT = 100;
exports.QUIZ_OVERVIEW_NAME_MIN_CHARS = 2;
exports.QUIZ_OVERVIEW_NAME_MAX_CHARS = 100;
exports.MAX_QUIZ_MODULES = 49; //2*modules + 1 quizOverview <= 100 item limit for transact write
exports.TRANSCRIPT_GENERATED_RESOURCE_TEXT_MIN_CHARS = 50;
exports.TEXT_BLOCK_MAX_CHARS = 40000;
exports.TEXT_BLOCK_MIN_CHARS = 50;
exports.TEXT_BLOCK_GENERATION_MIN_SUMMARIES_PER_CHARACTER = 1 / 750; //tends to undershoot so this ensure we create enough summaries for larger resources
exports.TEXT_BLOCK_GENERATION_MIN_SUMMARIES = 2;
exports.TEXT_BLOCK_GENERATION_MAX_SUMMARIES = 10;
exports.MC_WRONG_ANSWERS_COUNT = 3;
exports.MC_MIN_GENERATION_COUNT = 2;
exports.WF_MIN_GENERATION_COUNT = 2;
exports.WF_MIN_GENERATION_ALTERNATIVE_WORDS = 0;
exports.WF_MAX_GENERATION_ALTERNATIVE_WORDS = 2;
exports.GENERATE_ID_PLACEHOLDER = 'generate!';
exports.UPLOADED_CONTENT_MAX_FILE_SIZE = 26214400; // 25MB
exports.VALID_YOUTUBE_HOST_NAMES = ['www.youtube.com', 'youtube.com'];
exports.VALID_MINI_YOUTUBE_HOST_NAMES = ['youtu.be'];
//# sourceMappingURL=index.js.map